{
  "info": "Bilgiler",
  "negative": "Hata",
  "notice": "Uyarı",
  "positive": "Başarılı"
}
